import { memo, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useUnmount } from 'react-use';

import { isVideoClipTask } from '~/components/VideoClipTasks/isVideoClipTask';
import { VideoClipTasksPanel } from '~/components/VideoClipTasks/VideoClipTasksPanel';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { removeTasksAction } from '~/store/tasks/actions';
import { makeAssetTransformationTasksSelectorByWorkspaceId } from '~/store/tasks/selectors';
import { useAirSelector } from '~/utils/ReduxUtils';
import { useCancelTask } from '~/utils/taskUtils/useCancelTask';

export const PrivateVideoClipTasksPanel = memo(() => {
  const { currentWorkspace } = useCurrentWorkspace();
  const dispatch = useDispatch();
  const { cancelTask } = useCancelTask();

  const tasksSelector = useMemo(
    () => makeAssetTransformationTasksSelectorByWorkspaceId(currentWorkspace?.id),
    [currentWorkspace?.id],
  );

  const allTransformationTasks = useAirSelector(tasksSelector);
  const videoClipTasks = useMemo(() => allTransformationTasks.filter(isVideoClipTask), [allTransformationTasks]);

  useUnmount(() => {
    dispatch(
      removeTasksAction({
        taskIds: videoClipTasks.map(({ localTaskId }) => localTaskId),
      }),
    );
  });

  if (videoClipTasks.length < 1) {
    return null;
  }

  return <VideoClipTasksPanel tasks={videoClipTasks} onCancel={cancelTask} onClear={cancelTask} />;
});

PrivateVideoClipTasksPanel.displayName = 'PrivateVideoClipTasksPanel';
